
import { TrashIcon } from "../Icon";


export const HelpPreview = (data: any, index: number, getImageDetails: Function, handleEditFileList: Function, isDelete?: boolean) => {
    return (
        <>
       
            <div className="mt-3 mr-4 d-flex align-center justify-center " key={index}>
                </div>
                {isDelete && <div
                    className="pointer ml-2"
                    onClick={() => {
                        handleEditFileList?.(index)
                    }}
                >
                    <TrashIcon />
                </div>}
            {/* </div> */}
        </>
    );

}